export enum RootRoutes {
  EXIT = "exit",
  COMPLETED = "completed",
  RESET = "reset",
}
